/* CANFOTO · ETAP2 · HOME GDX330 R2 · LIVE-SAFE NATIVE SECTION */
(() => {
  'use strict';
  if (window.__CANFOTO_GDX330_HOME_R2_BOOTED__) return;
  window.__CANFOTO_GDX330_HOME_R2_BOOTED__ = true;

  const VERSION='CANFOTO-ETAP2-HOME-GDX330-R3-FULL-SURFACE-COLLECTION-CLICK';
  const MOBILE_MQ=window.matchMedia('(max-width: 720px)');
  const PROFILES=['cf-editorial','cf-magazine','cf-nature','cf-newsroom','cf-retrofuture','cf-redaxis','cf-chrome','cf-cinema','cf-hyperpop'];
  const FALLBACK='cf-cinema';
  const states=new WeakMap();

  function profile(){
    const raw=document.documentElement.getAttribute('data-cf-theme')||FALLBACK;
    return PROFILES.includes(raw)?raw:FALLBACK;
  }
  function mode(){return MOBILE_MQ.matches?'mobile':'desktop'}
  function mapFor(section){
    const id=section?.dataset?.cfGdx330SourceMap;
    const node=id?document.getElementById(id):null;
    if(!node) return {};
    try{return JSON.parse(node.textContent||'{}')}catch(_){return {}}
  }
  function state(section){
    let s=states.get(section);
    if(!s){s={token:0,io:null};states.set(section,s)}
    return s;
  }
  function parts(section){
    return {
      viewport:section.querySelector('[data-cf-gdx330-viewport]'),
      frame:section.querySelector('[data-cf-gdx330-frame]')
    };
  }
  function geometry(){return mode()==='mobile'?{w:1080,h:1350}:{w:1200,h:628}}
  const CLICK_TARGET='/collections/tripodlar-ve-monopodlar';
  function withFullSurfaceClickOwner(html){
    const code=`<script id="canfotoGdx330FullSurfaceClickOwner">(function(){'use strict';var TARGET='${CLICK_TARGET}';function go(){try{window.top.location.assign(TARGET)}catch(_){window.location.href=TARGET}}document.addEventListener('click',function(e){e.preventDefault();e.stopImmediatePropagation();go()},true);document.documentElement.setAttribute('data-cf-gdx330-full-click','1');document.documentElement.style.cursor='pointer';})();<\/script>`;
    return String(html||'').includes('</body>')
      ? String(html).replace('</body>',code+'</body>')
      : String(html||'')+code;
  }
  function fit(section){
    const {viewport,frame}=parts(section); if(!viewport||!frame)return;
    const g=geometry();
    const width=Math.max(1,viewport.clientWidth||section.clientWidth||window.innerWidth);
    const scale=width/g.w;
    frame.style.width=`${g.w}px`;
    frame.style.height=`${g.h}px`;
    frame.style.transform=`scale(${scale})`;
    section.dataset.cfGdx330Mode=mode();
    section.dataset.cfGdx330Scale=scale.toFixed(6);
    section.dataset.cfGdx330RenderedWidth=String(Math.round(width));
    section.dataset.cfGdx330RenderedHeight=String(Math.round(g.h*scale));
  }
  function ensurePayload(section,p){
    window.CANFOTO_GDX330_R2_PAYLOADS=window.CANFOTO_GDX330_R2_PAYLOADS||{};
    if(window.CANFOTO_GDX330_R2_PAYLOADS[p]) return Promise.resolve(window.CANFOTO_GDX330_R2_PAYLOADS[p]);
    const src=mapFor(section)[p];
    if(!src) return Promise.reject(new Error('MISSING_PAYLOAD_URL:'+p));
    return new Promise((resolve,reject)=>{
      const id='cf-gdx330-r2-payload-'+p;
      let tag=document.getElementById(id);
      const done=()=>{
        const payload=window.CANFOTO_GDX330_R2_PAYLOADS?.[p];
        payload?resolve(payload):reject(new Error('PAYLOAD_NOT_REGISTERED:'+p));
      };
      if(tag){
        if(tag.dataset.loaded==='1') return done();
        tag.addEventListener('load',done,{once:true});
        tag.addEventListener('error',()=>reject(new Error('PAYLOAD_LOAD_FAILED:'+p)),{once:true});
        return;
      }
      tag=document.createElement('script');
      tag.id=id; tag.src=src; tag.defer=true;
      tag.addEventListener('load',()=>{tag.dataset.loaded='1';done()},{once:true});
      tag.addEventListener('error',()=>reject(new Error('PAYLOAD_LOAD_FAILED:'+p)),{once:true});
      document.head.appendChild(tag);
    });
  }
  async function render(section,force=false){
    if(!section?.isConnected)return;
    const {frame}=parts(section); if(!frame)return;
    const p=profile(), m=mode(), s=state(section);
    if(!force && section.dataset.cfGdx330Ready==='1' && section.dataset.cfGdx330Profile===p && section.dataset.cfGdx330LoadedMode===m){fit(section);return}
    const token=++s.token;
    section.dataset.cfGdx330Ready='0';
    section.dataset.cfGdx330Profile=p;
    section.dataset.cfGdx330LoadedMode=m;
    try{
      const payload=await ensurePayload(section,p);
      if(token!==s.token||!section.isConnected)return;
      const doc=payload?.[m];
      if(!doc?.html)throw new Error('MISSING_DOCUMENT:'+p+':'+m);
      const mark=()=>{
        if(token!==s.token||!section.isConnected)return;
        section.dataset.cfGdx330Ready='1';
        section.dataset.cfGdx330Source=doc.source||'';
        fit(section);
      };
      frame.onload=mark;
      frame.srcdoc=withFullSurfaceClickOwner(doc.html);
      fit(section);
      requestAnimationFrame(()=>requestAnimationFrame(mark));
      setTimeout(mark,180);
    }catch(err){
      section.dataset.cfGdx330Error=String(err?.message||err);
      section.dataset.cfGdx330Ready='0';
      console.error('[CANFOTO GDX330 R2]',err);
    }
  }
  function lazy(section){
    if(!section?.isConnected)return;
    fit(section);
    const s=state(section);
    if(s.io){s.io.disconnect();s.io=null}
    if(!('IntersectionObserver'in window)){render(section);return}
    s.io=new IntersectionObserver(entries=>{
      if(!entries.some(e=>e.isIntersecting))return;
      render(section); s.io.disconnect(); s.io=null;
    },{root:null,rootMargin:'800px 0px',threshold:.01});
    s.io.observe(section);
  }
  function sections(root=document){return Array.from(root.querySelectorAll?.('[data-cf-gdx330-home]')||[])}
  function boot(root=document){sections(root).forEach(lazy)}
  let raf=0;
  function fitAll(){cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>sections().forEach(fit))}
  function renderAll(){sections().forEach(s=>render(s,true))}

  new MutationObserver(rs=>{if(rs.some(r=>r.type==='attributes'&&r.attributeName==='data-cf-theme'))renderAll()})
    .observe(document.documentElement,{attributes:true,attributeFilter:['data-cf-theme']});
  window.addEventListener('resize',fitAll,{passive:true});
  window.addEventListener('orientationchange',fitAll,{passive:true});
  if(MOBILE_MQ.addEventListener)MOBILE_MQ.addEventListener('change',renderAll); else MOBILE_MQ.addListener(renderAll);
  window.addEventListener('canfoto:experience-change',renderAll);
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  document.addEventListener('shopify:section:unload',e=>{
    const sec=e.target?.querySelector?.('[data-cf-gdx330-home]');
    const s=sec&&states.get(sec); if(s?.io)s.io.disconnect();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true}); else boot();

  window.debugCanFotoHomeGdx330R2=()=>sections().map(section=>{
    const {viewport,frame}=parts(section); let innerSize=null,productHref=null;
    try{
      innerSize=frame?.contentDocument?.querySelector('meta[name="canfoto-ad-size"]')?.content||null;
      productHref=frame?.contentDocument?.querySelector('a[href*="/collections/tripodlar-ve-monopodlar"]')?.href||null;
    }catch(_){}
    return {version:VERSION,sectionId:section.dataset.cfGdx330SectionId||null,profile:section.dataset.cfGdx330Profile||null,mode:section.dataset.cfGdx330Mode||null,ready:section.dataset.cfGdx330Ready||null,source:section.dataset.cfGdx330Source||null,innerSize,productHref,clickTarget:CLICK_TARGET,fullSurfaceClickOwner:frame?.contentDocument?.documentElement?.getAttribute('data-cf-gdx330-full-click')||null,ratio:viewport?getComputedStyle(viewport).aspectRatio:null,error:section.dataset.cfGdx330Error||null};
  });
})();
